var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section grid-view", staticStyle: { padding: "10px 20px" } },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          {
            staticClass: "operations",
            staticStyle: { "margin-bottom": "5px" }
          },
          [
            _c("div", { staticClass: "triggers" }, [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "new",
                        disabled: !_vm.isEdit || !_vm.canAdd,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.showEditDialog(true)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "edit",
                        disabled: !_vm.isEdit,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.showEditDialog(false)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { disabled: !_vm.isEdit, type: "danger" },
                      on: { click: _vm.remove }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                  )
                ],
                1
              )
            ])
          ]
        ),
        _c(
          "div",
          { staticClass: "grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "grid-params": _vm.girdParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.girdParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.girdParams = $event
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "450px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.WarehouseType") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { no: "warehouseType" },
                          model: {
                            value: _vm.editDialog.form.warehouseType,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.editDialog.form,
                                "warehouseType",
                                $$v
                              )
                            },
                            expression: "editDialog.form.warehouseType"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("Partners.ordinary"),
                              value: 0
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("Partners.supervise"),
                              value: 1
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("SeaExport.BackUpWarehouse"),
                              value: 2
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.WareHouseName") } },
                    [
                      _c("el-input", {
                        attrs: { no: "warehouseName" },
                        model: {
                          value: _vm.editDialog.form.warehouseName,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "warehouseName", $$v)
                          },
                          expression: "editDialog.form.warehouseName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.contactPerson") } },
                    [
                      _c("el-input", {
                        attrs: { no: "warehouseContact" },
                        model: {
                          value: _vm.editDialog.form.warehouseContact,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.editDialog.form,
                              "warehouseContact",
                              $$v
                            )
                          },
                          expression: "editDialog.form.warehouseContact"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Tel") } },
                    [
                      _c("el-input", {
                        attrs: { no: "warehouseContactTel" },
                        model: {
                          value: _vm.editDialog.form.warehouseContactTel,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.editDialog.form,
                              "warehouseContactTel",
                              $$v
                            )
                          },
                          expression: "editDialog.form.warehouseContactTel"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.WarehouseAddress") } },
                    [
                      _c("el-input", {
                        attrs: { no: "warehouseAddress" },
                        model: {
                          value: _vm.editDialog.form.warehouseAddress,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.editDialog.form,
                              "warehouseAddress",
                              $$v
                            )
                          },
                          expression: "editDialog.form.warehouseAddress"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.WarehouseMap") } },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            no: "warehouseMap",
                            action: "",
                            "auto-upload": false,
                            accept: "image/png, image/jpeg",
                            "list-type": "picture",
                            "file-list": _vm.editDialog.fileList,
                            limit: 1,
                            "on-change": _vm.toChooseFile,
                            "on-remove": _vm.toRemoveFile
                          }
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { no: "mapFileName", type: "primary" } },
                            [_vm._v(_vm._s(_vm.$t("FileHistory.Upload")))]
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#999999",
                                "font-size": "10px",
                                "padding-left": "3px"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_WarehouseMapTip"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.isDefault") } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { no: "defaultWarehouse" },
                          on: { change: _vm.onDefaultChange },
                          model: {
                            value: _vm.editDialog.form.defaultWarehouse,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.editDialog.form,
                                "defaultWarehouse",
                                $$v
                              )
                            },
                            expression: "editDialog.form.defaultWarehouse"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            { attrs: { no: "yes", label: true } },
                            [_vm._v(_vm._s(_vm.$t("Message.Yes")))]
                          ),
                          _c(
                            "el-radio",
                            { attrs: { no: "no", label: false } },
                            [_vm._v(_vm._s(_vm.$t("Message.No")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.LoadingRemarks") } },
                    [
                      _c("el-input", {
                        attrs: { no: "remarks", type: "textarea", rows: 9 },
                        model: {
                          value: _vm.editDialog.form.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.editDialog.form, "remarks", $$v)
                          },
                          expression: "editDialog.form.remarks"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Partners.warehousingRequirements")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "warehousingRequirements" },
                        model: {
                          value: _vm.editDialog.form.warehousingRequirements,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.editDialog.form,
                              "warehousingRequirements",
                              $$v
                            )
                          },
                          expression: "editDialog.form.warehousingRequirements"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.associatedRoute") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "associatedRoute",
                          "select-type": _vm.selectTypeNames.basic_data_Region,
                          "default-multiple-value": _vm.regionUuids,
                          "tag-value": "uuid",
                          multiple: ""
                        },
                        on: { parentCallBack: _vm.regionCallBack }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.saveSub }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }